import { isNullOrUndefinedOrEmpty } from "../filter-value";

// Loan-creation gate for the Current Loan Dashboard. Until the real Encompass loan exists
// (the Dashboard creates it lazily on the first save), Income Documentation Type, Loan
// Originator and Loan Processor must all be selected in the prerequisite card — the wizard
// never creates a loan without an LO/LP either (requiredFields.js).

export const PREREQUISITE_REQUIRED_MESSAGE =
	"Select the Income Documentation Type, Loan Originator and Loan Processor before saving.";

const PREREQUISITE_KEYS = ["incomeDocumentationType", "loanOriginatorId", "loanProcessorId"];

/**
 * @param {{incomeDocumentationType?: string, loanOriginatorId?: string|number,
 *   loanProcessorId?: string|number}} data
 * @param {boolean} loanExists true once the real Encompass loan has been created
 * @returns {Set<string>} the missing keys (empty once the loan exists)
 */
export const getCreationPrerequisiteErrors = (data, loanExists) => {
	const errors = new Set();
	if (loanExists) return errors;
	PREREQUISITE_KEYS.forEach((key) => {
		if (isNullOrUndefinedOrEmpty(data?.[key])) errors.add(key);
	});
	return errors;
};
